import ScheduledMeetingActions from "./ScheduledMeetingActions";
import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import { INTERVIEWS_CHANGED, loadInterviews, openInterviewScheduler } from "../utils/interviewScheduling";

export default function InterviewScheduleInline({ candidateId, jobId, stage, candidate, job }) {
  const [interviews, setInterviews] = useState([]);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!candidateId) return;
    let active = true;
    const load = () => loadInterviews({ candidateId, jobId }).then(data => {
      if (active) { setInterviews(data.interviews || []); setError(""); }
    }).catch(() => { if (active) setError("Interview times unavailable"); });
    load(); window.addEventListener(INTERVIEWS_CHANGED, load);
    return () => { active = false; window.removeEventListener(INTERVIEWS_CHANGED, load); };
  }, [candidateId, jobId]);
  const context = { candidateId, jobId, stage, candidate, job };
  return <Box sx={{ mt: 1, minWidth: 0 }} onClick={event => event.stopPropagation()}>
    <Button size="small" startIcon={<EventOutlinedIcon />} disabled={!candidateId} onClick={() => openInterviewScheduler(context)}>Schedule</Button>
    {error && <Typography variant="caption" color="error">{error}</Typography>}
    {interviews.filter(item => item.interview_status !== "cancelled").sort((a, b) => Date.parse(a.starts_at) - Date.parse(b.starts_at)).map(item => <Box key={item.id}><Button size="small"
      onClick={() => openInterviewScheduler({ ...context, interviewId: item.id })}
      sx={{ display: "block", textAlign: "left", textTransform: "none", whiteSpace: "normal", overflowWrap: "anywhere", fontSize: 12 }}>
      {new Date(item.starts_at).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" })}
      {item.interview_status === "confirmed" ? " - Confirmed" : ""}
    </Button><ScheduledMeetingActions record={item} /></Box>)}
  </Box>;
}
